import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';
export const FormError = styled.span`
  margin: 0;
  font-size: 14px;
  color: ${colors.secondaryLadyBug};
`;

export default FormError;


// WEBPACK FOOTER //
// ./src/components/Form/styles/FormError.js